<template>
  <component :is="as" class="o-linkbox__overlay" v-bind="$attrs" v-on="$listeners"><slot /></component>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    as: {
      default: 'a',
    },
  },
});
</script>

<style lang="scss">
.o-linkbox__overlay {
  position: static;
  &:before {
    content: '';
    cursor: inherit;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
